import { ComponentType, ReactNode, SVGProps } from "react"
import { theme } from "../../../../../../styles/stitches.config"
import { Spacer } from "../../../../../../components/spacer/Spacer"
import Text from "../../../../../../components/Text"
import { Flex } from "../../../../../../components/flex/Flex"
import { Button } from "../../../../../../components/button/Button"
import { Div } from "../../../../../../components/div/Div"
import { SCard } from "./SCard"
import { useIsMobileVersion } from "../../../../../../hooks/mediaHooks"

type ProductCardProps = {
  header: ReactNode
  description: ReactNode
  icon: ComponentType<SVGProps<SVGSVGElement>>
  selected?: boolean
  onChange?: () => void
}

export function ProductCard(props: ProductCardProps) {
  const { header, description, icon, selected, onChange } = props
  const Icon = icon

  const isMobile = useIsMobileVersion()

  return (
    <SCard selected={selected} vertical style={{ height: isMobile ? "auto" : theme.sizes.s122.value }}>
      <Flex direction="column" justify="between" style={{ height: "100%" }}>
        {!isMobile && <Icon width={250} height={250} />}

        {isMobile && (
          <Flex direction="column" align="center">
            <Div style={{ width: 100, height: 100 }}>
              <Icon width={100} height={100} />
            </Div>
            <Spacer size={theme.space.s3} />
            <Text
              type="headerH2"
              css={{ textTransform: "uppercase", fontWeight: 700, lineHeight: "32px", letterSpacing: "1.2px" }}
            >
              {header}
            </Text>
          </Flex>
        )}

        <Div style={{ padding: "0 20px" }}>
          {!isMobile && (
            <Text
              type="headerH2"
              css={{ textTransform: "uppercase", fontWeight: 700, lineHeight: "32px", letterSpacing: "1.2px" }}
            >
              {header}
            </Text>
          )}

          <Spacer size={theme.space.s6} />
          <Text type="textsSmall" css={{ lineHeight: "24px" }}>
            {description}
          </Text>
          <Spacer size={theme.space.s6} />
          <Flex justify="center">
            <Button
              type="button"
              variant={"primary"}
              onClick={onChange}
              style={{ textTransform: "uppercase", width: "100%" }}
            >
              {selected ? "Vybráno" : "Vybrat"}
            </Button>
          </Flex>
        </Div>
      </Flex>
    </SCard>
  )
}
